export default {
  'get-list': {
    method: 'post',
    url: '/client/driver/list'
  },
  add: {
    method: 'post',
    url: '/client/driver'
  },
  delete: {
    method: 'delete',
    url: '/client/driver'
  },
  update: {
    method: 'put',
    url: '/client/driver/ID'
  },
  get: {
    method: 'get',
    url: '/client/driver/ID'
  },
  changeStatus: {
    method: 'put',
    url: '/client/driver/status'
  },
  select: {
    method: 'get',
    url: '/client/driver/find?key=KEY'
  },
  archive: {
    method: 'delete',
    url: '/client/driver/archive'
  },
  restore: {
    method: 'put',
    url: '/client/driver/restore'
  },
  selectByLicenseType: {
    method: 'get',
    url: '/client/driver/find'
  }
}
